import { useState } from "react"
import { TextField, Typography, Button, Box, Snackbar, Alert } from "@mui/material"
import axios from "axios"
import { ChangeLanguage, loginSuccess } from "../../store/auth/authReducer"
import { useAppDispatch } from "../../store"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { decodeToken } from "react-jwt"

export default function LoginPage() {
    const dispatch = useAppDispatch()

    //Declaring local states of a component
    const [loading, setLoading] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [formData, setFormData] = useState({
        login: "",
        password: ""
    })


    //We take the state from the storage (whether there is a token or not)
    const isLoggedIn = useSelector(
        (state: any) => !!state.auth.authData.accessToken
      )

    //Closing the snackbar (appears when the login data is incorrect)
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //The function of sending login data, receiving a token and writing to the state store and local storage
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    let getUserData = async (login: string, pass: string) => { 
        setLoading(true) 
        try { 
            const response = await axios.post('https://cardgarantsales.com/restapi/authenticate', { 
            }, 
                { 
                    auth: { 
                        username: login, 
                        password: pass 
                    } 
                } 
            ); 
            setLoading(false) 
            console.log(decodeToken(response.data.access_token))
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('username', decodeToken<any>(response.data.access_token).username);
            localStorage.setItem('accesslevel', decodeToken<any>(response.data.access_token).accesslevel);
            localStorage.setItem('id', decodeToken<any>(response.data.access_token).sub);
            localStorage.setItem('targetlanguage', decodeToken<any>(response.data.access_token).language);
            localStorage.setItem('partner', decodeToken<any>(response.data.access_token).partner);

            
            dispatch(ChangeLanguage(decodeToken<any>(response.data.access_token).language))
            
            dispatch(loginSuccess(response.data.access_token));    
             
        } catch (error) { 
            //With an unsuccessful login, opening a snack bar with an error
            setLoading(false) 
            console.log(error);
            setOpenSnackbar(true) 
        } 
    } 


    return (
        <Box style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <form style={{
                display: "flex",
                flexDirection: "column",
                width: 300,
                height: 250,
                justifyContent: "space-between",
            }}>
                <Typography textAlign={"center"} variant="h5">
                    Login
                </Typography>
                <TextField name="username" autoComplete="username" value={formData.login} onChange={(e) => setFormData({ ...formData, login: e.target.value })} id="outlined-basic" label="Login" variant="outlined" />
                <TextField name="password" autoComplete="current-password" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} id="outlined-basic" label="Password" variant="outlined" />
                <Button type="submit" onClick={() => getUserData(formData.login, formData.password)} disabled={loading} variant="contained">Log in</Button>
            </form>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    Incorrect login or password!
                </Alert>
            </Snackbar>
            {
            //If the token is found in the localstorage, go to the main page
            isLoggedIn && <Navigate to="/" replace />
            }
        </Box>
    )
}